import { useEffect, useState } from 'react';
import { ThemeModeEnum } from '@app/configs/theme/enums/theme';
import { AppThemeContext } from '../context';

const themeLocalStorageKey = 'appTheme';

const getIsDarkModeMediaQuery = () => window.matchMedia('(prefers-color-scheme: dark)');
const getThemeFromLocalStorage = () => {
  const storedMode = localStorage.getItem(themeLocalStorageKey);

  if (!storedMode) {
    localStorage.setItem(themeLocalStorageKey, ThemeModeEnum.light);
    return ThemeModeEnum.light;
  }

  return storedMode as ThemeModeEnum;
};

const AppThemeProvider = ({ children }) => {
  const [mode, setMode] = useState<ThemeModeEnum>(getThemeFromLocalStorage);
  const [isDark, setIsDark] = useState<boolean>(
    mode === ThemeModeEnum.system ? getIsDarkModeMediaQuery().matches : mode === ThemeModeEnum.dark,
  );

  const changeMode = (mode: ThemeModeEnum) => {
    localStorage.setItem(themeLocalStorageKey, mode);
    setMode(mode);
  };

  useEffect(() => {
    const darkModeMediaQuery = getIsDarkModeMediaQuery();

    setIsDark(mode === ThemeModeEnum.system ? darkModeMediaQuery.matches : mode === ThemeModeEnum.dark);

    const updateDarkMode = (e: MediaQueryListEvent) =>
      mode === ThemeModeEnum.system ? setIsDark(e.matches) : void 0;

    darkModeMediaQuery.addEventListener('change', updateDarkMode);

    return () => darkModeMediaQuery.removeEventListener('change', updateDarkMode);
  }, [mode]);

  return <AppThemeContext.Provider value={{ isDark, changeMode, mode }}>{children}</AppThemeContext.Provider>;
};

export { AppThemeProvider };
